var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', [_c(_vm.layout, {
    tag: "component"
  }), _c('helper-maintenance-mode', {
    attrs: {
      "show-dialog": _vm.maintenanceDialog
    }
  }), _c('helper-version-dialog', {
    attrs: {
      "show-dialog": _vm.versionDialog,
      "version": _vm.appState
    }
  }), _c('helper-notification'), _c('helper-permission-dialog')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }